import { clsx } from "clsx";
import { LLMSummary } from "../@types/LLMSummary";
import SelectRowsProvider from "../../../../../../../enhancers/SelectRowsProvider";
import styles from "../llm-summary.module.scss";
import LLMSummaryWarning from "../LLMSummaryWarning";
import LLMSectionText from "./LLMSectionText";
import LLMThinkingSteps from "./LLMThinkingSteps";
import LLMIocGrid from "./LLMIocGrid";

type Props = {
  summary: LLMSummary["summary"];
  isProcessing?: boolean;
};

const LLMSummaryContent = ({ summary, isProcessing }: Props) => {
  const hasAnyData = Object.values(summary?.summary || {})
    .map(item => item?.text?.length)
    .some(Boolean);
  return (
    <div className={"flex flex-gap-4"} style={{ flexDirection: "column" }}>
      <LLMSummaryWarning />

      {summary?.thinking_steps &&
        (summary?.thinking_steps?.length ?? 0) > 0 && (
          <LLMThinkingSteps
            thinkingSteps={summary?.thinking_steps}
            isProcessing={isProcessing}
          />
        )}

      {hasAnyData && (
        <div
          className={clsx(
            styles.llm_summary_content,
            styles.llm_summary_content_border,
            "p-10"
          )}
        >
          {summary?.summary?.executive_summary && (
            <LLMSectionText
              data={summary.summary.executive_summary}
              viewType="text"
              title="Executive Summary"
            />
          )}
          {summary?.summary?.file_behavior && (
            <LLMSectionText
              data={summary.summary.file_behavior}
              viewType="text"
              title="Behavior"
            />
          )}
          {summary?.summary?.classification && (
            <LLMSectionText
              data={summary.summary.classification}
              viewType="text"
              title="Classification"
            />
          )}
          {summary?.summary?.file_info && (
            <LLMSectionText
              data={summary.summary.file_info}
              viewType="list"
              title="File Info"
            />
          )}
          {summary?.summary?.relationships && (
            <LLMSectionText
              data={summary.summary.relationships}
              viewType="list"
              title="Relationships"
            />
          )}
          {summary?.summary?.network_references && (
            <LLMSectionText
              data={summary.summary.network_references}
              viewType="list"
              title="Network References"
            />
          )}
        </div>
      )}

      <SelectRowsProvider>
        <LLMIocGrid summary={summary} />
      </SelectRowsProvider>
    </div>
  );
};

export default LLMSummaryContent;
